export const mapConfig = process.env.REACT_APP_MAP_MAPBOX;

export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const ADMINS = ['dincelumit@gmail.com', 'brkkaramete@hotmail.com'];
